import {Message} from '../JobsPostAd/message';
import localStorageWrapper from '../LocalStorageWrapper';


export const INTEGRATIONS_FORMS_FIELDS = {
  NAME: 'name',
  MOBILE: 'mobile',
  EMAIL: 'email',
  CITY: 'city',
  AGE: 'age',
  SALARY: 'salary',
  PAN: 'pan',
  BIKE_USED_BOOL: 'bike_used_bool',
  BIKE_BUY_TIME: 'bike_buy_time',
  BIKE_BUDGET: 'bike_budget',
  EDUCATION: 'education'
};

export const INTEGRATIONS_FORMS_DETAILS = {
  loan: {
    key: 'loan',
    fields: [
      INTEGRATIONS_FORMS_FIELDS.NAME,
      INTEGRATIONS_FORMS_FIELDS.MOBILE,
      INTEGRATIONS_FORMS_FIELDS.EMAIL,
      INTEGRATIONS_FORMS_FIELDS.CITY,
      // INTEGRATIONS_FORMS_FIELDS.AGE,
      // INTEGRATIONS_FORMS_FIELDS.SALARY
    ]
  },
  insurance: {
    key: 'insurance',
    fields: [
      INTEGRATIONS_FORMS_FIELDS.NAME,
      INTEGRATIONS_FORMS_FIELDS.MOBILE,
      INTEGRATIONS_FORMS_FIELDS.EMAIL,
      INTEGRATIONS_FORMS_FIELDS.CITY,
      //INTEGRATIONS_FORMS_FIELDS.EDUCATION
    ]
  },
  bike: {
    key: 'bike',
    fields: [
      INTEGRATIONS_FORMS_FIELDS.NAME,
      INTEGRATIONS_FORMS_FIELDS.MOBILE,
      INTEGRATIONS_FORMS_FIELDS.EMAIL,
      INTEGRATIONS_FORMS_FIELDS.CITY,
      // INTEGRATIONS_FORMS_FIELDS.BIKE_USED_BOOL,
      // INTEGRATIONS_FORMS_FIELDS.BIKE_BUY_TIME,
      // INTEGRATIONS_FORMS_FIELDS.BIKE_BUDGET
    ]
  },
  deliveryExecutive: {
    key: 'deliveryExecutive',
    fields: []
  }
};

export const isFormSubmitted = (type) => {
  return localStorageWrapper && localStorageWrapper.hasKey(`IntegrationForm_${type}`);
};

export const setFormSubmitted = (type) => {
  localStorageWrapper && localStorageWrapper.setItem(`IntegrationForm_${type}`, 1);
};

const defaultIntegrationFormState = {
  form: {
    [INTEGRATIONS_FORMS_FIELDS.NAME]: {
      show: true,
      value: '',
      message: (new Message(1,0, '', { field: INTEGRATIONS_FORMS_FIELDS.NAME })).get()
    },
    [INTEGRATIONS_FORMS_FIELDS.MOBILE]: {
      show: true,
      value: '',
      message: (new Message(1,0, '', { field: INTEGRATIONS_FORMS_FIELDS.MOBILE })).get()
    },
    [INTEGRATIONS_FORMS_FIELDS.EMAIL]: {
      show: true,
      value: '',
      message: (new Message(1,0, '', { field: INTEGRATIONS_FORMS_FIELDS.EMAIL })).get()
    },
    [INTEGRATIONS_FORMS_FIELDS.CITY]: {
      show: true,
      value: '',
      message: (new Message(1,0, '', { field: INTEGRATIONS_FORMS_FIELDS.CITY })).get()
    },
    [INTEGRATIONS_FORMS_FIELDS.AGE]: {
      show: true,
      value: null,
      message: (new Message(1,0, '', { field: INTEGRATIONS_FORMS_FIELDS.AGE })).get()
    },
    [INTEGRATIONS_FORMS_FIELDS.PAN]: {
      show: true,
      value: null,
      message: (new Message(1,0, '', { field: INTEGRATIONS_FORMS_FIELDS.PAN })).get()
    },
    [INTEGRATIONS_FORMS_FIELDS.SALARY]: {
      show: true,
      value: null,
      message: (new Message(1,0, '', { field: INTEGRATIONS_FORMS_FIELDS.SALARY })).get()
    },
    [INTEGRATIONS_FORMS_FIELDS.BIKE_USED_BOOL]: {
      show: true,
      value: 'No',
      message: (new Message(1, 0, '', { field: INTEGRATIONS_FORMS_FIELDS.BIKE_USED_BOOL })).get()
    },
    [INTEGRATIONS_FORMS_FIELDS.BIKE_BUY_TIME]: {
      show: true,
      value: '',
      message: (new Message(1, 0, '', { field: INTEGRATIONS_FORMS_FIELDS.BIKE_BUY_TIME })).get()
    },
    [INTEGRATIONS_FORMS_FIELDS.BIKE_BUDGET]: {
      show: true,
      value: '',
      message: (new Message(1, 0, '', { field: INTEGRATIONS_FORMS_FIELDS.BIKE_BUDGET })).get()
    },
    [INTEGRATIONS_FORMS_FIELDS.EDUCATION]: {
      show: true,
      value: '',
      message: (new Message(1, 0, '', { field: INTEGRATIONS_FORMS_FIELDS.EDUCATION })).get()
    }
  },
  type: '',
  sourcesSet: {},
  forms: {
    loan: {
      status: isFormSubmitted('loan') ? 3 : 0 // 0: not open 1: open form 2: open confirmation form 3: submitted
    },
    insurance: {
      status: isFormSubmitted('insurance') ? 3 : 0
    },
    bike: {
      status: isFormSubmitted('bike') ? 3 : 0
    },
    deliveryExecutive: {
      status: isFormSubmitted('deliveryExecutive') ? 3 : 0
    }
  },
  values: {
    bike_used_bool: {
      'Yes': {
        id: 'Yes',
        checked: false,
        value: 'Yes',
      },
      'No': {
        id: 'No',
        checked: true,
        value: 'No',
      }
    },
    bike_buy_time: {
      'Immediately': {
        key: 'Immediately',
        value: 'Immediately',
      },
      'Within 1 month': {
        key: 'Within 1 month',
        value: 'Within 1 month',
      },
      'Within 3 months': {
        key: 'Within 3 months',
        value: 'Within 3 months',
      },
      'Not sure': {
        key: 'Not sure',
        value: 'Not sure',
      }
    },
    bike_budget: {
      'Less than 20k': {
        key: 'Less than 20k',
        value: 'Less than 20k',
      },
      '20k to 40k': {
        key: '20k to 40k',
        value: '20k to 40k',
      },
      '40k to 60k': {
        key: '40k to 60k',
        value: '40k to 60k',
      },
      '60k to 1 lakh': {
        key: '60k to 1 lakh',
        value: '60k to 1 lakh',
      },
      '1 lakh and above': {
        key: '1 lakh and above',
        value: '1 lakh and above',
      }
    },
    education: {
      'Below 12th': {
        key: 'Below 12th',
        value: 'Below 12th'
      },
      'Pursuing Graduation': {
        key: 'Pursuing Graduation',
        value: 'Pursuing Graduation'
      },
      'Graduate': {
        key: 'Graduate',
        value: 'Graduate'
      },
      'Post Graduate': {
        key: 'Post Graduate',
        value: 'Post Graduate'
      }
    }
  }
};

export const getDefaultState = () => {
  return defaultIntegrationFormState;
};

export const updateIntegrationFormFields = (integrationKey, integrationValue) => {
  if (INTEGRATIONS_FORMS_DETAILS[integrationKey]) {return;}

  INTEGRATIONS_FORMS_DETAILS[integrationKey] = {
    key: integrationKey,
    fields: [
      INTEGRATIONS_FORMS_FIELDS.NAME,
      INTEGRATIONS_FORMS_FIELDS.MOBILE,
      INTEGRATIONS_FORMS_FIELDS.EMAIL,
      INTEGRATIONS_FORMS_FIELDS.CITY,
    ]
  }
};



// WEBPACK FOOTER //
// ../q-jobs/src/utils/Integrations/utils.js